export class QuarantineState {
  fill_Batch_ID = 0;
  quarantined = false;
  firstname = '';
  lastname = '';
}
